var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mail_confirmed_label"},[_vm._v(" "+_vm._s(_vm.$t('mail-confirmed'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }